import React, { useState, useEffect } from "react";
import AddProduct from "../AddProduct";
import UpdateProduct from "../UpdateProduct";

const AddingProduct = () => {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState(null);
  const [products, setAllProducts] = useState([]); // ✅ Always initialize as an empty array
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductsData();
  }, []);

  // Fetch Products Data
  const fetchProductsData = async () => {
    try {
      const response = await fetch(
        "https://prakruthi.vercel.app/api/product/all"
      );
      const result = await response.json();

      // Extract the correct array from the API response
      const extractedProducts = Array.isArray(result.data) ? result.data : [];

      setAllProducts(extractedProducts);
      setLoading(false);
    } catch (err) {
      setAllProducts([]); // Prevents filter crash
      setLoading(false);
    }
  };

  // Open Update Modal
  const updateProductModalSetting = async (product) => {
    try {
      const response = await fetch(
        `https://prakruthi.vercel.app/api/product/edit-product/${product._id}`
      );
      const data = await response.json();
      setUpdateProduct(data);
      setShowUpdateModal(true);
    } catch (err) {
      console.error("Error fetching product for update:", err);
    }
  };

  // Toggle Add Product Modal
  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Delete Product
  const deleteItem = async (id) => {
    try {
      await fetch(`https://prakruthi.vercel.app/api/product/delete/${id}`, {
        method: "DELETE",
      });
      fetchProductsData(); // Refresh product list
    } catch (err) {
      console.error("Error deleting product:", err);
    }
  };
  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        {showProductModal && (
          <AddProduct
            addProductModalSetting={() => setShowProductModal(false)}
          />
        )}
        {showUpdateModal && (
          <UpdateProduct
            updateProductData={updateProduct}
            closeModal={() => setShowUpdateModal(false)}
          />
        )}

        {/* Table Section */}
        <div className="overflow-x-auto rounded-lg border bg-white border-gray-200">
          <div className="flex justify-between pt-5 pb-3 px-3">
            <div className="flex gap-4 items-center">
              <span className="font-bold text-lg">Products</span>
              <div className="flex items-center px-2 border-2 rounded-md">
                <input
                  className="border-none outline-none text-xs px-2"
                  type="text"
                  placeholder="Search here"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm"
              onClick={() => setShowProductModal(true)}
            >
              Add Product
            </button>
          </div>

          {loading ? (
            <p className="text-center p-4">Loading products...</p>
          ) : (
            <table className="min-w-full divide-y-2 divide-gray-200 text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Image
                  </th>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Title
                  </th>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Brand
                  </th>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Category
                  </th>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Price
                  </th>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Stock
                  </th>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Status
                  </th>
                  <th className="px-4 py-2 text-left font-medium text-gray-900">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200">
                {Array.isArray(products) &&
                  products
                    .filter((product) =>
                      product.title
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    )
                    .map((product) => (
                      <tr key={product._id}>
                        <td className="px-4 py-2">
                          <img
                            src={
                              product.imageURLs?.[0]?.img || "placeholder.jpg"
                            }
                            alt={product.title}
                            className="w-16 h-16 object-cover rounded"
                          />
                        </td>
                        <td className="px-4 py-2 text-gray-900">
                          {product.title}
                        </td>
                        <td className="px-4 py-2 text-gray-700">
                          {product.brand?.name}
                        </td>
                        <td className="px-4 py-2 text-gray-700">
                          {product.category?.name}
                        </td>
                        <td className="px-4 py-2 text-gray-700">
                          ₹{product.price}
                        </td>
                        <td className="px-4 py-2 text-gray-700">
                          {product.quantity}
                        </td>
                        <td className="px-4 py-2 text-gray-700">
                          {product.status}
                        </td>
                        <td className="px-4 py-2 text-gray-700">
                          <button
                            className="text-green-600"
                            onClick={() => setUpdateProduct(product)}
                          >
                            Edit
                          </button>
                          <button
                            className="text-red-600 ml-2"
                            onClick={() => deleteItem(product._id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddingProduct;
